import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { MaterialsSection } from './components/MaterialsSection';
import { BonusSection } from './components/BonusSection';
import { WorkFormatSection } from './components/WorkFormatSection';
import { AudienceSection } from './components/AudienceSection';
import { MidPageCTA } from './components/MidPageCTA';
import { PurchaseSection } from './components/PurchaseSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Meta Pixel - Fresh Install
    try {
      const w = window as any;
      if (w.fbq) return;
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', '790333870788238');
      w.fbq('track', 'PageView');
    } catch (e) {
      console.warn('Meta Pixel failed to initialize:', e);
    }
  }, []);
  return <div className="min-h-screen font-sans" data-id="element-0" data-mp="33nq73vwxp979">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1" data-mp="38li8rhnds9on">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=790333870788238&ev=PageView&noscript=1" alt="" data-id="element-2" data-mp="38l03xwmnkn54" />
      </noscript>

      <UrgencyBar data-id="element-3" data-mp="nwc2huqftzxb" />

      <main data-id="element-4" data-mp="nur6s1se0axv">
        <HeroSection data-id="element-5" data-mp="nv0x5qhcgk43" />
        <PainSection data-id="element-6" data-mp="nxwx1kcr5iv6" />
        <SolutionSection data-id="element-7" data-mp="sudmqizlo5ad" />
        <MaterialsSection data-id="element-8" data-mp="stkn01z26g1q" />
        <BonusSection data-id="element-9" data-mp="sssqmoxn0eae" />
        <WorkFormatSection data-id="element-10" data-mp="swgm3tmn7arr" />
        <AudienceSection data-id="element-11" data-mp="35yngfn0fdzc" />
        <MidPageCTA data-id="element-12" data-mp="356s95xbri9l" />
        <PurchaseSection data-id="element-13" data-mp="34ndfy2z19zs" />

        <section className="py-6 px-4 bg-white" data-id="element-14" data-mp="3uct3bjmdin0h">
          <div className="max-w-3xl mx-auto text-center" data-id="element-15" data-mp="3ubzw6hji5vht">
            <p className="text-lg md:text-xl font-semibold text-gray-600 italic" data-id="element-16" data-mp="d4e94339pv1g">
              Creado por Aula Mater, proyecto educativo enfocado en facilitar el
              trabajo docente
            </p>
          </div>
        </section>

        <GuaranteeSection data-id="element-17" data-mp="3glwcnyc0cfw2" />
      </main>

      <footer className="bg-gray-900 text-gray-400 text-center py-8 px-4" data-id="element-18" data-mp="3bmbevr8kqdkx">
        <div className="max-w-3xl mx-auto space-y-3" data-id="element-19" data-mp="3bk6zod585s5c">
          <p className="text-sm text-gray-300" data-id="element-20" data-mp="3qbfud0nzi3pc">
            © 2026 Aula Mater. Todos los derechos reservados.
          </p>
          <p className="text-xs leading-relaxed" data-id="element-21" data-mp="3liwjwcklfoor">
            Este sitio no es parte del sitio web de Facebook ni de Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-22" data-mp="18cgc3m4xbphy" />
    </div>;
}